import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=6fe687fd&scoped=true&"
import script from "./LinkWidget.vue?vue&type=script&lang=ts&"
export * from "./LinkWidget.vue?vue&type=script&lang=ts&"
import style0 from "./LinkWidget.vue?vue&type=style&index=0&id=6fe687fd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe687fd",
  null
  
)

export default component.exports